var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuHelpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 100,
    viewBox: "0 0 64 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 50H50.75V56.25H44.5V50Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.75 43.75H57V50H50.75V43.75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.75 12.5H57V18.75H50.75V12.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 6.25H50.75V12.5H44.5V6.25Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 43.75H25.75V50H32V43.75Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 43.75H25.75V50H32V43.75Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 37.5H32V43.75H38.25V37.5Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 56.25H38.25V62.5H44.5V56.25Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 25H19.5V31.25H25.75V25Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 12.5H7V18.75H13.25V12.5Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6.25H13.25V12.5H19.5V6.25Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43.75H63.25V18.75H57V43.75Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 6.25V0H19.5V6.25H44.5Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.75H0.75V31.25H7V18.75Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 37.5V31.25H7V37.5H19.5Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 18.75V25H38.25V18.75H25.75Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 37.5H44.5V25H38.25V37.5Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 62.5H25.75V50H19.5V62.5Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 62.5V68.75H38.25V62.5H25.75Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 75V81.25H38.25V75H25.75Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 93.75H25.75V81.25H19.5V93.75Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 100V93.75H25.75V100H38.25Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 81.25H38.25V93.75H44.5V81.25Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25V31.25H7V18.75H13.25V12.5H19.5V6.25H44.5V12.5H50.75V18.75H57V43.75H50.75V50H44.5V56.25H38.25V62.5H25.75V50H32V43.75H38.25V37.5H44.5V25H38.25V18.75H25.75V25H19.5Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 81.25H25.75V93.75H38.25V81.25Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHelpIcon);
export default __webpack_public_path__ + "static/media/menu_help_icon.0e8e25f9d65a77c63bc7d8eef01eeb01.svg";
export { ForwardRef as ReactComponent };